import React, { useState } from "react";

function ShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Comprehensive Junk Removal in Campbell, CA</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p className="resid-rmv">
          <span>Residential Cleanouts:</span>&nbsp;Get rid of unwanted items
          like old furniture, mattresses, appliances, and household clutter with
          our efficient junk hauling services.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc">
            <p>
              <span>Commercial Junk Removal:</span>&nbsp;Our team handles office
              cleanouts, storage unit cleanups, and warehouse junk removal for
              businesses in Campbell, California, and surrounding areas. <br />
              <span>Construction Debris Removal:</span>&nbsp;We provide fast,
              reliable cleanup for construction sites, including scrap metal,
              yard waste, and bulky items.
              <br />
              <span>Heavy Lifting:</span>&nbsp;We take care of the heavy lifting
              so you don’t have to.
              <br />
              <span>Hot Tub Removal:</span>&nbsp;Need to get rid of an old hot
              tub? We offer safe and efficient hot tub removal.
              <br />
              <span>Mattress Removal:</span>&nbsp;We handle the removal of old
              mattresses with eco-friendly disposal.
              <br />
              <span>Yard Waste Removal:</span>&nbsp;Clear yard debris such as
              branches, leaves, and grass with our efficient team.
              <br />
              <span>Furniture Disposal:</span>&nbsp;We’ll take away old
              furniture, from couches and chairs to tables and cabinets.
              <br />
              <span>E-Waste Disposal:</span>&nbsp;Safely dispose of electronic
              waste like old computers, printers, and tech equipment.
              <br />
              <span>Trash Removal:</span>&nbsp;We remove unwanted junk and
              trash, making space in your home or office.
              <br />
              <span>Junk Hauling Services:</span>&nbsp;Our team handles junk
              hauling for all types of items, large and small.
              <br />
              <span>Free Junk Removal Estimates:</span>&nbsp;Get a free quote
              with no hidden fees and flat rate pricing.
              <br />
              <span>Same-Day Service:</span>&nbsp;We offer same-day junk removal
              for those last-minute cleanups.
              <br />
              <span>Eco-Friendly Junk Removal:</span>&nbsp;Our team uses
              eco-friendly disposal methods, ensuring that we reduce waste and
              recycle when possible.
            </p>
          </div>

          <h3>Serving Campbell, CA, and Surrounding Areas</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <p className="santa-junk-sec">
            We proudly serve Campbell, CA, and the greater Silicon Valley
            region, including Santa Clara County, Los Gatos, San Jose, Mountain
            View. Whether you need junk removal for your home, commercial
            property, or construction site, we’re here to provide fast,
            affordable, and professional service.
          </p>
          <h3>Contact Junk Droid for Junk Removal in Campbell, CA</h3>
          <div className="sliderline-svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="4"
              viewBox="0 0 64 4"
              fill="none"
            >
              <path
                d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                fill="#60BDFF"
              ></path>
            </svg>
          </div>

          <div className="junk-santa-desc">
            <p>
              Ready to clear out your unwanted junk? Call Junk Droid for a free
              estimate today! Whether it’s old appliances, furniture disposal,
              or construction debris removal, we offer reliable and affordable
              junk removal services in Campbell, CA. Get in touch with us now to
              book your same-day junk removal.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default ShowHide;
